import { api } from "../../../lib/api";
import { VendorFormData, VendorResponse } from "./vendor.types";

class VendorService {
  /**
   * Submit Vendor Registration Form
   * @param {VendorFormData} payload
   * @returns {Promise<VendorResponse>}
   */
  async registerVendor(payload) {
    try {
      const response = await api.post("contactForm/vendor", payload);

      return new VendorResponse(true, response.data.data);
    } catch (error) {
      console.log("erroraaa:::::::", error)
      const message =
        error.response?.data?.data?.error ||
        "Failed to submit vendor registration form. Please try again later.";

      return new VendorResponse(false, { error: message });
    }
  }
}

export const vendorService = new VendorService();